import { Box, Divider, Paper, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import { Link } from "react-router-dom";
import SessionContext from "../contexts/session";
import GAMES from "../games";
import NETWORKS from "../networks";
import { useTranslation, Trans } from "react-i18next";

export default function Footer() {
  const { selectedNetwork } = useContext(SessionContext);
  const { t, i18n } = useTranslation();
  return (
    <Stack
      component={Paper}
      variant="outlined"
      spacing={4}
      sx={{ px: 6, py: 4, alignItems: "center" }}
    >
      <Box
        sx={{
          display: "grid",
          gap: 4,
          textAlign: "center",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "1fr 1fr 1fr 1fr",
          },
          width: "100%",
        }}
      >
        {[
          [
            { text: t("Our games") },
            ...Object.values(GAMES).map((game) => ({
              link: game.url,
              text: t(game.name),
            })),
          ],
          [
            { text: t("Network")+": " + selectedNetwork.chainName },
            {
              externalLink: selectedNetwork.ui.duneUrl,
              text: "Dune Analytics",
            },
            {
              externalLink: `${selectedNetwork.ui.explorerUrl}/address/${selectedNetwork.contract.address}`,
              text: t("Smart Contract"),
            },
            { externalLink: "https://github.com/nice2win", text: "Github" },
          ],
          [
            { text: t("More info on") },
            { link: "/faq", text: t("FAQ") },
            { externalLink: "https://medium.com/@nice2win", text: "Medium" },
            { link: "/team", text: t("Team") },
            { link: "/terms-of-service", text: t("Terms of Service") },
          ],
          [
            { text: t("Reach out to us") },
            {
              externalLink: "https://twitter.com/nice2winDapp",
              text: "Twitter",
            },
            {
              externalLink: "https://discord.com/invite/r97TVvmgng",
              text: "Discord",
            },
            {
              externalLink: "https://www.youtube.com/@nice2win58",
              text: "Youtube",
            },
            {
              externalLink: "https://www.tiktok.com/@nice2win",
              text: "TikTok",
            },
            {
              externalLink: "https://www.instagram.com/nice2windapp",
              text: "Instagram",
            },
          ],
        ].map((row, rowIndex) => (
          <Stack key={rowIndex} spacing={1}>
            {row.map((item, itemIndex) => (
              <div key={itemIndex}>
                {item.link || item.externalLink ? (
                  item.link ? (
                    <Box
                      component={Link}
                      sx={{
                        color: "primary.main",
                        ":hover": { color: "primary.dark" },
                      }}
                      to={item.link}
                    >
                      {item.text}
                    </Box>
                  ) : (
                    <Box
                      component="a"
                      target="_blank"
                      rel="noreferrer"
                      sx={{
                        color: "primary.main",
                        ":hover": { color: "primary.dark" },
                      }}
                      href={item.externalLink}
                    >
                      {item.text}
                    </Box>
                  )
                ) : (
                  <Typography color="secondary">{item.text}</Typography>
                )}
              </div>
            ))}
          </Stack>
        ))}
      </Box>
      <Typography color="secondary"><Trans t={t}>Available on</Trans></Typography>
      <Stack spacing={4}>
        <Stack
          direction="row"
          sx={{
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 4,
          }}
        >
          {Object.values(NETWORKS).filter(network => !network.disabled).map((network) => (
            <Typography
              key={network.chainId}
              fontWeight="bold"
              sx={{ whiteSpace: "nowrap" }}
            >
              <Box
                component="img"
                sx={{
                  mr: 1,
                  filter: "grayscale(100%)",
                  verticalAlign: "middle",
                }}
                src={network.ui.menuIcon}
                height={36}
              />

              {network.chainName}
            </Typography>
          ))}
        </Stack>
        <Divider />
        <img
          src="/img/logo248.svg"
          alt="nice2win logo"
          height={36}
          style={{ alignSelf: "center", filter: "grayscale(100%)" }}
        />
      </Stack>
      <Typography>© {new Date().getFullYear()} nice2win.com</Typography>
    </Stack>
  );
}
